export const Bazaarvoice = {
    methods: {
        initBazaarvoiceCatalogData(jsonBazaarvoiceCatalogData) {
            if (jsonBazaarvoiceCatalogData) {
                window.bvDCC = JSON.parse(jsonBazaarvoiceCatalogData)
                window.bvCallback = function (BV) {
                    BV.pixel.trackEvent("CatalogUpdate", {
                        type: 'Product',
                        locale: window.bvDCC.catalogData.locale,
                        catalogProducts: window.bvDCC.catalogData.catalogProducts
                    })
                }
            }
        }
    }
}
